import { buildQueryString } from './../../../helpers/src/QueryHelper';
import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { ApiResult } from '@crema/models/Apps';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

const HOLIDAY_URL = '/api/holidays';

export const holidayApi = createApi({
  reducerPath: 'holiday.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['holidayInfo'],
  endpoints: (builder) => ({
    getListHoliday: builder.query({
      query: ({
        pageNo = 0,
        pageSize = DEFAULT_ROWS_PER_PAGE,
        type = '',
        country = '',
        from = '',
        to = '',
        name = '',
        sort = '',
        warehouseId = '',
      }) => {
        const queryString = buildQueryString({
          pageNo,
          pageSize,
          type,
          country,
          from,
          to,
          name,
          sort,
          warehouseId,
        });
        return { url: `${HOLIDAY_URL}?${queryString}` };
      },
      transformResponse: (response, meta: any) => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        } as ApiResult;
      },
      keepUnusedDataFor: 5,
      providesTags: ['holidayInfo'],
    }),
    getHolidayById: builder.query({
      query: (id) => ({ url: `${HOLIDAY_URL}/${id}` }),
      providesTags: ['holidayInfo'],
    }),
    addHoliday: builder.mutation({
      query: (body) => ({
        url: `${HOLIDAY_URL}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['holidayInfo'],
    }),
    deleteHoliday: builder.mutation({
      query: (id) => ({
        url: `${HOLIDAY_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['holidayInfo'],
    }),
    updateHoliday: builder.mutation({
      query: (data) => ({
        url: `${HOLIDAY_URL}/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['holidayInfo'],
    }),
    updateHolidayPosition: builder.mutation({
      query: (data) => ({
        url: `${HOLIDAY_URL}/position`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['holidayInfo'],
    }),
  }),
});

export const {
  useGetListHolidayQuery,
  useGetHolidayByIdQuery,
  useAddHolidayMutation,
  useDeleteHolidayMutation,
  useUpdateHolidayMutation,
  useUpdateHolidayPositionMutation,
} = holidayApi;
